import $ from 'jquery'
import {orgText} from './get.js'

const getCadsCacheMinify = (orgId, callbackFunc) => {
  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/caches/cads_cache_minify' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function(res) {
    let result = JSON.parse(res)
    callbackFunc(result)
  })
}

export {getCadsCacheMinify}
